import React, { FC } from 'react';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { IStudentBookBagBookmark } from 'src/config/api/models/Book';
import {
  StyledBookmarkWrapper,
  StyledLink,
  StyledTrajectoryTitle,
  StyledTypography,
  TrajectoriesContentWrapper,
  TrajectoriesListHeader,
  TrajectoriesListWrapper,
} from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import {
  TrajectorySectionCode,
  TrajectorySectionType,
  trajectorySectionCodeLookup,
} from 'src/config/api/models/Trajectory';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';
import { BlankLink } from 'src/modules/shared/components';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import { setScroll } from 'src/modules/shared/slices/bookmark/entity/bookmarkEntity';
import { LogActionTypes, useDataLogging } from 'src/modules/shared/data-logging';

type Props = {
  bookmark?: IStudentBookBagBookmark[];
};

const BookmarkTrajectoriesList: FC<Props> = ({ bookmark }) => {
  const { getPath } = useI18nPath();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const theme = useTheme();
  const log = useDataLogging();

  const handleClick = (item: IStudentBookBagBookmark) => {
    dispatch(setScroll({ shouldScroll: true, blockId: item.blockId }));
    const actionType: LogActionTypes = item.fromMyTeacher
      ? LogActionTypes.STUDENT_READ_TEACHER_BOOKMARK_BOOK_PAGE
      : LogActionTypes.STUDENT_READ_BOOKMARK_BOOK_PAGE;

    log(actionType, {
      bookId: item.bookId,
      trajectoryId: item.trajectoryId,
      blockId: item.blockId,
      pageId: item.pageId,
      bookmarkId: item.bookmarkId,
    });
  };

  return (
    <TrajectoriesListWrapper>
      <TrajectoriesListHeader>
        <FontAwesomeSpriteIcon
          icon={SpriteIconsLight.BOOKMARK}
          color={theme.palette.secondary.main}
        />{' '}
        {'Bladwijzer'}
      </TrajectoriesListHeader>
      <TrajectoriesContentWrapper>
        {bookmark?.length ? (
          <>
            {bookmark.map((item) => {
              return (
                <StyledLink
                  onClick={() => handleClick(item)}
                  to={getPath('trajectoryView', {
                    bookId: item.bookId,
                    chapterId: item.chapterId,
                    trajectoryId: item.trajectoryId,
                    'sectionCode?': Object.keys(trajectorySectionCodeLookup).find(
                      (key) =>
                        trajectorySectionCodeLookup[key as TrajectorySectionCode] ===
                        (item.section as TrajectorySectionType)
                    ),
                    'sectionName?': t(`trajectory.sections.${item.section}.title`).toLowerCase(),
                    'seriesId?': item.section === 'exercises' ? item.pageId : undefined,
                  })}
                >
                  <StyledBookmarkWrapper>
                    <StyledTypography>
                      {item.fromMyTeacher ? 'Van je leerkracht: ' : 'Van jou: '}
                    </StyledTypography>{' '}
                    <StyledTrajectoryTitle> {item.title}</StyledTrajectoryTitle>
                  </StyledBookmarkWrapper>
                </StyledLink>
              );
            })}
          </>
        ) : (
          <StyledTrajectoryTitle>
            Nog geen bladwijzer.{' '}
            <BlankLink to="/nl-be/boekentas/06f1ab77-e078-4cee-9591-d11601076a23/hoofdstukken/f23543c2-d94c-4d16-93e4-5a984f7c323d/traject/c79e39af-25a9-47b4-bfad-9e6b579536db/0/opbouw/">
              Zo plaats je die
            </BlankLink>
            .
          </StyledTrajectoryTitle>
        )}
      </TrajectoriesContentWrapper>
    </TrajectoriesListWrapper>
  );
};

export default BookmarkTrajectoriesList;
